<template>
  <div class="big-box">
    <div class="scroll-box">
      <div class="big-box-img" :style="{ 'background-image': `url(${bgUrl})` }">
        <div class="big-body">
          <img :src="tapTopUrl" alt="" class="tap-top" />
          <div class="theme" :style="{ color: customerPaperwork.titleColor }">
            {{ customerPaperwork.title }}
          </div>
          <div class="desc" :style="{ color: customerPaperwork.titleColor }">
            {{ customerPaperwork.desc }}
          </div>
          <div class="flexc-cen-x time-box">
            活动距结束
            <span class="time-item mlr2">30</span>
            天
            <span class="time-item mlr2">12</span>
            : <span class="time-item mlr2">12</span> :
            <span class="time-item mlr2">12</span>
          </div>
          <div
            class="step-tab-box"
            :style="{ 'background-image': `url(${stepTabUrl})` }"
          >
            <div class="tab-box flexc-cen-x">
              <div
                class="tab-item"
                v-for="(item, index) in newStepList"
                :key="item.value"
                @click="handleGetCurrent(item.value)"
              >
                <div class="tab-item-text">{{ item.stageName }}</div>
                <div
                  v-if="item.value == current"
                  class="active-bar"
                  :style="{
                    background: `linear-gradient(90deg, ${customerPaperwork.progressLeftColor} 0%, ${customerPaperwork.progressMiddleColor} 54%, ${customerPaperwork.progressRightColor} 100%)`,
                  }"
                ></div>
                <div v-else class="active-bar"></div>
                <div class="time-item">XX时XX分XX秒</div>
              </div>
            </div>
          </div>
          <template v-if="current == 0 && ruleDTO.activityScene == 1">
            <div
              class="exclusive-price"
              :style="{ 'background-image': `url(${exclusiveUrl})` }"
              v-if="firstStageConfig.enableExclusivePrice"
            >
              <div class="exclusive-price-text">入会XX小时限时秒</div>
              <div class="exclusive-price-time">倒计时：XX时XX分XX秒</div>
              <div
                class="flexc-cen-x price-box"
                v-if="designatedSku.length > 0"
              >
                <div class="prize-logo">
                  <img :src="designatedSku[0].logo" alt="" />
                </div>
                <div class="prize-info">
                  <div class="prize-name">{{ designatedSku[0].skuName }}</div>
                  <div class="prize-jd-price">
                    京东价：￥{{ designatedSku[0].jdPrice }}
                  </div>
                  <div class="prize-price">
                    惊喜到手价￥<span class="price-font">{{
                      designatedSku[0].exclusivePrice
                    }}</span>
                  </div>
                  <div
                    class="add-btn"
                    :style="{
                      color: customerPaperwork.memberBtnWordColor,
                      'background-image': `url(${memberBtnUrl})`,
                    }"
                  >
                    一键加购
                  </div>
                </div>
              </div>
              <div class="tips-box">
                <img
                  class="tips-icon"
                  src="https://cdn-image.yucrm.cn/cad6c702ffb84411a8498c0f5fff5859.png"
                  alt=""
                />
                <div :style="{ color: customerPaperwork.memberWordColor }">
                  <div>仅购买改秒杀产品会失去领取下方首购礼资格哦！</div>
                  <div>请在XX小时内下单，超过XX小时将不再有秒杀资格。</div>
                </div>
              </div>
            </div>
          </template>
          <div
            :style="{ 'background-image': `url(${trialModelUrl})` }"
            class="trial-model"
            v-if="ruleDTO.activityScene == 2 && current == 0"
          >
            <div
              class="trial-model-text"
              :style="{ color: customerPaperwork.modelWordColor }"
            >
              下单试用装，领取试用奖品
            </div>
            <div class="flexc-cen-x trial-prize" v-if="trialProduct.length > 0">
              <div class="trial-item">
                <img :src="trialProduct[0].logo" alt="" class="trial-logo" />
                <div class="trial-name">{{ trialProduct[0].title }}</div>
                <div class="buy-btn">
                  <span class="price-font">￥{{ trialProduct[0].price }}</span>
                  <div class="buy-btn-text">购买</div>
                </div>
              </div>
              <div class="trial-item" v-if="trialProduct.length > 1">
                <img :src="trialProduct[1].logo" alt="" class="trial-logo" />
                <div class="trial-name">{{ trialProduct[1].title }}</div>
                <div class="buy-btn">
                  <span class="price-font">￥{{ trialProduct[0].price }}</span>
                  <div class="buy-btn-text">购买</div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="prize-model"
            :style="{ 'background-image': `url(${prizeModelUrl})` }"
            v-if="purchaseOrderConfig.prizeConfig.enabled || current != 0"
          >
            <div class="membership-title">
              <img
                src="https://cdn-image.yucrm.cn/05fdaf94b75a4150a2cda610049e6afe.png"
                alt=""
              />
              <span
                class="membership-title-name"
                :style="{ color: customerPaperwork.modelWordColor }"
                >{{ getText }}</span
              >
              <img
                src="https://cdn-image.yucrm.cn/c1f8b4aa6c3d49609350e7fd4c7250d3.png"
                alt=""
              />
            </div>
            <div class="membership-prize" v-if="newList.length > 0">
              <div class="membership-prize-logo">
                <img :src="newList[0].goodsList[0].logo" alt="" />
                <div class="prize-num">
                  剩余{{ newList[0].goodsList[0].totalAmount || 0 }}份
                </div>
              </div>
              <div class="prize-name">
                {{ newList[0].goodsList[0].title }}
              </div>
              <div
                class="prize-condition"
                v-if="
                  current != 0 ||
                  (firstStageConfig.enableFirstPurchase &&
                    purchaseOrderConfig.prizeConfig.enabled)
                "
              >
                领奖条件：单笔满{{ newList[0].orderAmtLimit }}元
              </div>
              <div
                class="prize-condition"
                v-if="current == 0 && ruleDTO.activityScene == 2"
              >
                领奖条件：下单{{ newList[0].condition }}商品
              </div>
            </div>
            <div class="give-btn-new">
              立即领取
              <img
                class="give-btn-new-icon"
                src="https://cdn-image.yucrm.cn/1fb232647cb047f489263fce74fde007.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="title" v-if="!oneShow">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    oneShow: {
      type: Boolean,
      default: false,
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    repurchaseStages: {
      type: Array,
      default: () => [],
    },
    firstStageConfig: {
      type: Object,
      default: () => ({
        enableExclusivePrice: false,
        enableFirstPurchase: false,
      }),
    },
    designatedSku: {
      type: Array,
      default: () => [
        {
          skuName: "",
          jdPrice: "",
          exclusivePrice: "",
          logo: "",
        },
      ],
    },
    prizeList: {
      type: Array,
      default: () => [],
    },
    purchaseOrderConfig: {
      type: Object,
      default: () => ({
        orderTimeConfig: {
          timeType: 1,
          joinDays: "",
          startTime: null,
          endTime: null,
        },
        orderRuleConfig: {
          orderPaymentType: this.venderType ? 1 : 0,
          filterType: 0,
          skuIdList: [],
        },
        prizeConfig: {
          enabled: false,
          sendType: 0,
          delayDays: null,
          delayDays2: null,
        },
      }),
    },
    trialProduct: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      newList: [],
      couponLogo: "https://cdn-image.yucrm.cn/images/V24/popup_coupon.png",
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
      current: 0,
    };
  },
  computed: {
    bgUrl() {
      return this.ruleDTO.cusTemplateJSON &&
        JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        ? JSON.parse(this.ruleDTO.cusTemplateJSON).activityBgImg
        : this.backgroundImage;
    },
    stepTabUrl() {
      return this.customerPaperwork.stepTabUrl
        ? this.customerPaperwork.stepTabUrl
        : (this.templateObj &&
            this.templateObj.configJson &&
            JSON.parse(this.templateObj.configJson).url6) ||
            "";
    },
    newStepList() {
      let list = this.repurchaseStages.map((item, index) => {
        return {
          stageName: item.stageName,
          value: index + 1,
        };
      });
      if (this.firstStageConfig.enableExclusivePrice) {
        list.unshift({
          stageName: "会员首购礼",
          value: 0,
        });
        this.current = list[0].value;
      }
      if (this.ruleDTO.activityScene == 2) {
        list.unshift({
          stageName: "试用尝鲜",
          value: 0,
        });
      }
      this.current = list[0].value;
      return list;
    },
    exclusiveUrl() {
      return this.customerPaperwork.memberModelUrl
        ? this.customerPaperwork.memberModelUrl
        : this.templateObj.url2;
    },
    memberBtnUrl() {
      return this.customerPaperwork.memberBtnUrl
        ? this.customerPaperwork.memberBtnUrl
        : this.templateObj.url3;
    },
    prizeModelUrl() {
      return this.customerPaperwork.prizeModelUrl
        ? this.customerPaperwork.prizeModelUrl
        : (this.templateObj &&
            this.templateObj.configJson &&
            JSON.parse(this.templateObj.configJson).url4) ||
            "";
    },
    trialModelUrl() {
      return this.customerPaperwork.trialModelUrl
        ? this.customerPaperwork.trialModelUrl
        : (this.templateObj &&
            this.templateObj.configJson &&
            JSON.parse(this.templateObj.configJson).url5) ||
            "";
    },
    newPrizeList() {
      if (this.current != 0) {
        // this.newList = this.repurchaseStages[this.current-1].stepPrizeList;
        return this.repurchaseStages[this.current - 1].stepPrizeList;
      } else {
        const prizeListCopy = [...this.prizeList];
        if (this.ruleDTO.activityScene == 2) {
          prizeListCopy.forEach((item) => {
            if (this.trialProduct.length > 0) {
              this.trialProduct.forEach((row) => {
                if (
                  item.specifiedProduct.length > 0 &&
                  item.specifiedProduct[0].skuId == row.skuId
                ) {
                  item.condition = row.title;
                }
              });
            }
          });
        }
        // this.newList = this.prizeList;
        return prizeListCopy;
      }
    },
    getText() {
      if (this.current != 0) {
        if (this.current == 1 && this.firstStageConfig.enableFirstPurchase) {
          return "复购领好礼";
        } else if (this.current == 1 && this.ruleDTO.activityScene == 2) {
          return this.repurchaseStages[this.current - 1].orderRuleConfig
            .skuIdList.length > 0 &&
            this.repurchaseStages[this.current - 1].orderRuleConfig
              .filterType == 1
            ? "下单指定商品领好礼"
            : "下单领好礼";
        } else {
          return "连续复购享好礼";
        }
      } else {
        return "入会后首次下单赢好礼";
      }
    },
  },
  watch: {
    current: {
      handler(newVal, oldVal) {
        // this.newList = this.newPrizeList
        this.updateNewList();
      },
      immediate: true,
    },
    prizeList: {
      handler(newVal) {
        this.updateNewList();
      },
      deep: true, // 深监听，确保 prizeList 内部数据变化也能被捕获
    },
    trialProduct: {
      handler(newVal) {
        this.updateNewList();
      },
      deep: true, // 深监听，确保 trialProduct 内部数据变化也能被捕获
    },
  },
  mounted() {},
  methods: {
    handleGetCurrent(value) {
      this.current = value;
    },
    updateNewList() {
      // 统一更新 newList 的方法
      this.newList = this.newPrizeList;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 1;
  background-color: #ffffff;

  .scroll-box {
    // width: 100%;
    width: 284px;
    overflow: auto;
    height: 560px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    border-radius: 24px;
  }

  .big-box-img {
    border-radius: 24px;
    width: 284px;
    height: 755px;
    background-repeat: no-repeat;
    background-size: 100%;
    padding-bottom: 20px;
  }
  .big-body {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .tap-top {
      margin-top: 8px;
    }
    .theme {
      font-weight: 600;
      font-size: 18px;
      margin-top: 20px;
      text-transform: none;
    }
    .desc {
      margin: 11px auto;
      height: 10px;
      font-weight: 400;
      font-size: 11px;
      text-align: center;
      line-height: 10px;
      font-style: normal;
      text-transform: none;
    }

    .time-box {
      margin: 0 auto;
      text-align: center;
      font-size: 8px;
      color: #666666;
      .time-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 13px;
        height: 13px;
        background: #333333;
        border-radius: 2px 2px 2px 2px;
        color: #ffffff;
      }
    }

    .step-tab-box {
      position: relative;
      margin: 33px auto 0;
      width: 266px;
      height: 52px;
      padding: 8px;
      background-repeat: no-repeat;
      background-size: 100%;
      .tab-box {
        height: 38px;
        overflow-x: auto;
        overflow-y: hidden;
        .tab-item {
          flex-shrink: 0;
          width: 50%;
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 10px;
          color: #21242b;
          line-height: 10px;
          text-align: center;
          font-style: normal;
          text-transform: none;

          .active-bar {
            margin: 4px 0;
            width: 127px;
            height: 8px;
            border-radius: 19px 19px 19px 19px;
          }

          .tab-item-text {
            font-family: PingFang SC, PingFang SC;
            font-weight: 500;
            font-size: 10px;
            color: #21242b;
            line-height: 10px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
          .time-item {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 8px;
            color: rgba(33, 36, 43, 0.7);
            line-height: 8px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
        &::-webkit-scrollbar {
          // width: 0;
          height: 2px;
          // display: none;
        }
      }
    }

    .exclusive-price {
      position: relative;
      margin-top: 12px;
      width: 265px;
      height: 197px;
      padding: 8px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      &-text {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #1a1a1a;
        line-height: 12px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      &-time {
        margin-top: 4px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 8px;
        color: rgba(26, 26, 26, 0.6);
        line-height: 8px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .price-box {
        margin-top: 30px;

        .prize-logo {
          width: 79px;
          height: 79px;
          border-radius: 5px 5px 5px 5px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 5px 5px 5px 5px;
          }
        }
        .prize-info {
          flex: 1;
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          .prize-name {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 11px;
            color: #1a1a1a;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .prize-jd-price {
            margin-top: 6px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 9px;
            color: #999999;
            line-height: 9px;
            text-align: left;
            font-style: normal;
            text-decoration-line: line-through;
            text-transform: none;
          }

          .prize-price {
            margin-top: 8px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 600;
            font-size: 8px;
            line-height: 8px;
            text-align: left;
            font-style: normal;
            text-transform: none;
            color: #f8304b;
            .price-font {
              font-size: 13px;
            }
          }
          .add-btn {
            flex: 1;
            align-self: flex-end;
            width: 55px;
            height: 20px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 9px;
            color: #ffffff;
            line-height: 9px;
            text-align: center;
            font-style: normal;
            line-height: 20px;
            text-transform: none;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            border-radius: 19px 19px 19px 19px;
          }
        }
      }

      .tips-box {
        position: absolute;
        left: 8px;
        bottom: 8px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 8px;
        line-height: 13px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        display: flex;
        align-items: center;
        .tips-icon {
          width: 22px;
          height: 26px;
          margin-right: 6px;
        }
      }
    }

    .trial-model {
      margin-top: 10px;
      padding: 25px;
      width: 265px;
      height: 231px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      &-text {
        margin-top: -16px;
        margin-left: 40px;
        font-weight: 500;
        font-size: 12px;
        color: #1a1a1a;
        line-height: 12px;
        text-align: center;
        font-style: normal;
        text-transform: none;
      }
      .trial-prize {
        width: 100%;
        margin-top: 20px;
        margin-left: -15px;
        .trial-item {
          margin-right: 10px;
          width: 118px;
          height: 177px;
          background: #ffffff;
          border-radius: 9px 9px 9px 9px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 8px;
          .trial-logo {
            width: 102px;
            height: 102px;
            border-radius: 6px 6px 6px 6px;
          }
          .trial-name {
            margin-top: 5px;
            width: 94px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 11px;
            color: #5a4444;
            line-height: 11px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .buy-btn {
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 103px;
            height: 21px;
            background: #ffefd9;
            font-size: 9px;
            border-radius: 19px 19px 19px 19px;
            .price-font {
              padding-left: 6px;
              font-weight: 500;
              color: #1a1a1a;
            }
            &-text {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 38px;
              height: 18px;
              background: linear-gradient(91deg, #4a4133 0%, #141211 100%);
              border-radius: 19px 19px 19px 19px;
              color: #ffffff;
            }
          }
          &:last-child {
            margin-right: 0;
          }
        }
      }
    }

    .prize-model {
      margin-top: 10px;
      padding: 25px;
      width: 265px;
      height: 250px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 10px;
      .membership-title {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        &-name {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 12px;
          color: #1a1a1a;
          line-height: 12px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
      }
      .membership-prize {
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        &-logo {
          position: relative;
          width: 120px;
          height: 120px;
          border-radius: 6px;
          img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
          }
          .prize-num {
            padding: 6px;
            width: fit-content;
            height: 18px;
            background: rgba(0, 0, 0, 0.5);
            border-radius: 12px 0px 12px 0px;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            font-size: 12px;
          }
        }
        .prize-name {
          margin-top: 12px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #1a1a1a;
          line-height: 14px;
          text-align: center;
          font-style: normal;
          text-transform: none;
        }
        .prize-condition {
          margin-top: 10px;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 12px;
          color: #999999;
          line-height: 12px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }

      .give-btn-new {
        position: relative;
        margin-top: 8px;
        width: 180px;
        padding: 8px;
        // height: 30px;
        border-radius: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 13px;
        color: #ffffff;
        background: linear-gradient(91deg, #4a4133 0%, #141211 100%);
        &-icon {
          width: 180px;
          position: absolute;
          left: -10px;
        }
      }
    }
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
  .ml4 {
    margin-left: 4px;
  }
  .ml6 {
    margin-left: 6px;
  }
  .mr6 {
    margin-right: 6px;
  }
  .mlr2 {
    margin: 0 2px;
  }
  .mlr6 {
    margin: 0 6px;
  }
  .mb6 {
    margin-bottom: 6px;
  }
  .ml12 {
    margin-left: 12px;
  }
  .fvertical {
    display: flex;
    align-items: center;
  }
  .fcc {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .color-grey {
    display: inline-block;
    width: 1px;
    height: 7px;
    background-color: #cecece;
  }
}
</style>
